<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import StatusBanner from "../components/StatusBanner.vue";
import { DEMO_ALGORITHM_WAREHOUSES } from "../features/bulkOrderCreation/demoShippingScenario.ts";
import ShippingPoGenerationWorkspace from "../features/bulkOrderCreation/ShippingPoGenerationWorkspace.vue";
import type { DropdownOption } from "../redistribution/models/DropdownOption.ts";
import { fetchWarehouses } from "../services/purchaseOrderService.ts";
import { useBulkOrderCreationStore } from "../stores/bulkOrderCreationStore.ts";

const router = useRouter();
const store = useBulkOrderCreationStore();
const warehouses = ref<DropdownOption[]>(
  store.demoMode ? DEMO_ALGORITHM_WAREHOUSES : []
);
const warehousesLoading = ref(!store.demoMode && store.rows.length > 0);
const warehouseError = ref("");
onMounted(async () => {
  if (!warehousesLoading.value) return;
  try {
    warehouses.value = await fetchWarehouses();
  } catch (error) {
    warehouseError.value =
      error instanceof Error
        ? error.message
        : "Warehouse options could not be loaded.";
  } finally {
    warehousesLoading.value = false;
  }
});

function backToLookup(): void {
  void router.push({ name: "dashboard-bulk-order-creation" });
}
</script>

<template>
  <div class="page-main-container overflow-y-auto">
    <button type="button" class="btn btn-secondary" @click="backToLookup">
      Back to lookup
    </button>
    <h2>Calculate Shipping POs</h2>
    <template v-if="store.rows.length > 0">
      <p>{{ store.identifier }} · {{ store.rows.length }} SKU lines</p>
      <StatusBanner v-if="warehouseError" variant="error" role="alert">{{
        warehouseError
      }}</StatusBanner>
      <ShippingPoGenerationWorkspace
        :identifier="store.identifier"
        :intermediate-order-id="
          store.mode === 'intermediate-order' ? store.identifier : undefined
        "
        :rows="store.rows"
        :demo-mode="store.demoMode"
        :warehouse-options="warehouses"
        :lookup-loading="warehousesLoading"
        :lookup-valid="!warehouseError"
      />
    </template>
    <div v-else>
      <p>
        No order context was found. Return to Bulk Order Creation and look up an
        order.
      </p>
      <button type="button" class="btn btn-primary" @click="backToLookup">
        Go to Bulk Order Creation
      </button>
    </div>
  </div>
</template>
